import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './LayoutComponents.css';

const Footer = () => (
  <footer className="footer">
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const Layout = ({ onLogout }) => {
  return (
    <div className="layout-container">
      <Sidebar />
      <div className="layout-main-content">
        <Navbar onLogout={onLogout} />
        <div className="layout-content-area">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout; 